
export const getStructuredDataForProductPage = (product) => {
    const productName = product.wineName ?
        product.wineName.replace(/^(vinho|vho) /ig, '') : '';

    const seoName = product.seoName;
    const productPrice = product.helpvinoPrice;
    const productImageURL = product.wineImageURL;
    const productNotes = product.wineNotes;
    const webPageShortURL = `https://dashboard.helpvino.com/produto/${product.wineProductId}`;
    const helpvinoLogoURL = 'https://hevi-api.s3.sa-east-1.amazonaws.com/images/logos/helpvino-transparente.png';

    let weightValue, weightUnitCode;
    let refQuantityValue, refQuantityUnitCode;

    if (productName.toLowerCase().includes('375ml') ||
            productName.toLowerCase().includes('375 ml')) {
        weightValue = '650';
        weightUnitCode = 'GRM';
        refQuantityValue = '375';
        refQuantityUnitCode = 'MLT';
    } else if (productName.toLowerCase().includes('1,5') ||
            productName.toLowerCase().includes('1500ml') ||
            productName.toLowerCase().includes('1500 ml')) {
        weightValue = '2.6';
        weightUnitCode = 'KGM';
        refQuantityValue = '1.5';
        refQuantityUnitCode = 'LTR';
    } else {
        weightValue = '1.3';
        weightUnitCode = 'KGM';
        refQuantityValue = '750';
        refQuantityUnitCode = 'MLT';
    }

    const currentDate = new Date();

    const priceValidUntil =
        `${currentDate.getUTCFullYear()+1}` + '-' +
        `${currentDate.getUTCMonth()+1}`.padStart(2, '0') + '-' +
        `${currentDate.getUTCDate()}`.padStart(2, '0');

    const productData = {
        "@type": "Product",
        "@id": `${webPageShortURL}/#product`,
        "name": `Vinho ${productName}`,
        "sku": `${product.wineProductId}`,
        "description": `Compre o vinho ${productName} no Marketplace Helpvino.`,
        "category": `Vinho ${product.wineTypeName} > ${product.grapeTypeName}`,
        "url": `${webPageShortURL}/${seoName}`,
        "weight": {
            "@type": "QuantitativeValue",
            "value": weightValue,
            "unitCode": weightUnitCode
        },
        "image": {
            "@id": `${webPageShortURL}/#image`
        },
        "mainEntityOfPage": {
            "@id": `${webPageShortURL}/#webpage`
        },
        "review": {
            "@type": "Review",
            "name": `Vinho ${productName}`,
            "inLanguage": "Portuguese",
            "author": {
                "@id": "https://www.helpvino.com.br/#organization"
            },
            "reviewBody": productNotes
        },
        "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "itemCondition": "http://schema.org/NewCondition",
            "price": `${productPrice}`,
            "priceValidUntil": priceValidUntil,
            "priceCurrency": "BRL",
            "priceSpecification": {
                "@type": "UnitPriceSpecification",
                "price": `${productPrice}`,
                "priceCurrency": "BRL",
                "referenceQuantity": {
                    "@type": "QuantitativeValue",
                    "value": refQuantityValue,
                    "unitCode": refQuantityUnitCode
                }
            },
            "seller": {
                "@id": "https://www.helpvino.com.br/#organization"
            }
        }
    };

    if (product.wineryName) {
        productData['brand'] = {
            "@type": "Brand",
            "name": product.wineryName
        };
    }

    return {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "Organization",
                "id": "https://www.helpvino.com.br/#organization",
                "name": "Helpvino",
                "legalName": "HELPVINO MARKETPLACE LTDA",
                "url": "https://www.helpvino.com.br",
                "sameAs": [
                    "https://www.instagram.com/helpvino",
                    "https://www.linkedin.com/company/help-vino",
                    "https://www.facebook.com/helpvino"
                ],
                "email": "contato@helpvino.com",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "Rua Nova Orleans, 34 - Brooklin",
                    "addressLocality": "São Paulo",
                    "addressRegion": "SP",
                    "addressCountry": "BR",
                    "postalCode": "04561-030"
                },
                "contactPoint": [
                    {
                        "@type": "ContactPoint",
                        "telephone": "(11) 9 1184-1428",
                        "contactType": "customer service",
                        "areaServed": "BR"
                    }
                ],
                "logo": {
                    "@type": "ImageObject",
                    "@id": "https://www.helpvino.com.br/#logo",
                    "url": helpvinoLogoURL,
                    "contentUrl": helpvinoLogoURL,
                    "caption": "Helpvino"
                },
                "image": {
                    "@id": "https://www.helpvino.com.br/#logo"
                }
            },
            {
                "@type": "WebSite",
                "@id": "https://dashboard.helpvino.com/#website",
                "name": "Dashboard Helpvino",
                "url": "https://dashboard.helpvino.com",
                "inLanguage": "pt-BR",
                "publisher": {
                    "@id": "https://www.helpvino.com.br/#organization"
                }
            },
            {
                "@type": "ImageObject",
                "@id": `${webPageShortURL}/#image`,
                "url": productImageURL,
                "contentUrl": productImageURL,
                "caption": `Vinho ${productName}`,
                "inLanguage": "pt-BR"
            },
            {
                "@type": "WebPage",
                "@id": `${webPageShortURL}/#webpage`,
                "url": `${webPageShortURL}/${seoName}`,
                "inLanguage": "pt-BR",
                "name": `Vinho ${productName} | Helpvino Marketplace`,
                "isPartOf": {
                    "@id": "https://dashboard.helpvino.com/#website"
                },
                "image": {
                    "@id": `${webPageShortURL}/#image`
                },
                "primaryImageOfPage": {
                    "@id": `${webPageShortURL}/#image`
                },
                "description": `Compre o vinho ${productName} no Marketplace Helpvino. Visite nossa homepage para verificar todos os vinhos disponíveis.`,
                "breadcrumb": {
                    "@id": `${webPageShortURL}/#breadcrumb`
                },
                "potentialAction": [
                    {
                        "@type": "BuyAction",
                        "target": [
                            `${webPageShortURL}/${seoName}`
                        ]
                    }
                ]
            },
            {
                "@type": "BreadcrumbList",
                "@id": `${webPageShortURL}/#breadcrumb`,
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "item": {
                            "@type": "WebPage",
                            "@id": "https://dashboard.helpvino.com",
                            "name": "Página inicial"
                        }
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "item": {
                            "@type": "WebPage",
                            "@id": "https://dashboard.helpvino.com/marketplace",
                            "name": "Marketplace"
                        }
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "item": {
                            "@type": "WebPage",
                            "@id": `${webPageShortURL}/${seoName}`,
                            "name": `Vinho ${productName}`
                        }
                    }
                ]
            },
            productData
        ]
    }
}
